import { Link } from 'react-router-dom';
import { useInView } from '../../hooks/useInView';
import styles from './ContractBanner.module.css';

export function ContractBanner() {
  const { ref, inView } = useInView();

  return (
    <section className={styles.section}>
      <div className="wrap">
        <div ref={ref} className={`${styles.inner} reveal ${inView ? 'visible' : ''}`}>
          <div className={styles.accent} />
          <div className={styles.text}>
            <p className={styles.title}>의료인 단체 또는 네트워크 의료기관이신가요?</p>
            <p className={styles.desc}>
              보다 효율적이고 연속성 있는 법률 자문을 위하여, 법무법인 오킴스 의료팀의
              정기자문계약을 고려해보시기 바랍니다.
            </p>
          </div>
          <Link to="/contract" className={styles.cta}>
            계약 안내 자세히 보기
            <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
              <path
                d="M3 8h10M9 4l4 4-4 4"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
}
